<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full"
      :visible.sync="modalVisible"
      :loading="contentLoading"
      notFooterPadding
      :contentStyle="{'height': '100%'}"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <template v-if="addOpType">
        添加装配单
      </template>
      <template v-if="viewOpType || editOpType">
        {{assemblyOrder.code}}
        <gj-tag
            type="plain"
            shape="rectangle"
            :color="assemblyOrder.status | optionColor(AssemblyOrderEnum.statusOption)">
          {{ assemblyOrder.status | optionText(AssemblyOrderEnum.statusOption) }}
        </gj-tag>
      </template>
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          style="height: 100%; display: flex;flex-direction: column;"
          :label-width="labelWidth">
        <gj-area-title>基本信息</gj-area-title>
        <template v-if="addOpType || editOpType">
          <el-row>
            <el-col :span="6">
              <el-form-item
                  label="自营仓"
                  prop="warehouseId"
                  :label-width="label1Width"
                  :rules="[$gjRequired('请选择自营仓')]">
                <gj-warehouse-select
                    v-model="form.warehouseId"
                    active
                    noValid
                    :fba="false"
                    :clearable="false"
                ></gj-warehouse-select>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item
                  label="备注"
                  prop="memo">
                <gj-input
                    v-model="form.memo"
                    :width="inputWidth"
                    placeholder="备注"
                ></gj-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else-if="viewOpType">
          <gj-desc-group
              :label-width="'90px'"
              style="margin-bottom: 10px;">
            <el-row>
              <el-col :span="8">
                <gj-desc
                    label="仓库"
                    :content="data.warehouseName">
                </gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc
                    label="创建人"
                    :content="data.createUserName">
                </gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc
                    label="创建时间"
                    :content="data.createTime">
                </gj-desc>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <gj-desc
                    label="备注"
                    :content="data.memo | defaultShow">
                </gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc
                    label="处理人"
                    :content="data.assembleUserName | defaultShow">
                </gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc
                    label="完成时间"
                    :content="data.completeTime | defaultShow">
                </gj-desc>
              </el-col>
            </el-row>
          </gj-desc-group>
        </template>
        <gj-area-title>产品明细</gj-area-title>
        <div v-if="addOpType || editOpType" style="margin-bottom: 10px;">
          <gj-button
              type="primary"
              @click="addProduct"
          >添加产品</gj-button>
          <gj-button
              @click="importProduct"
          >导入产品</gj-button>
        </div>
        <gj-table
            :index="false"
            adaptParent
            :loading="loading"
            name="opAssemblyOrder"
            :data="form.items"
            :columns="columns"
            border
            :highlight-hover-row="false"
            :offset-height="75"
            :structure-config="{type: 'ParentChild', children: 'childItems', spanType: 'row', parentSpan: ['0-2', 8]}"
            >
          <template v-slot:sku="{row}">
            <!-- <div><gj-image :src="row.skuImageUrl"></gj-image></div> -->
            <div>{{row.productName | defaultShow}}</div>
            <div>{{row.sku | defaultShow}}</div>
          </template>
          <template v-slot:childSku="{row}">
            <div>{{row.childProductName | defaultShow}}</div>
            <div>{{row.childSku | defaultShow}}</div>
          </template>
          <template v-slot:assemblyNum="{index,row}">
            <el-form-item
                v-if="addOpType || editOpType"
                :prop="`items.${row.$gjParentIndex}.quantity`"
                :rules="[
                  { required: true, message: '请输入装配数量', trigger: ['change'] },
                  $gjReRule(RE.pt, '请输入大于0的整数')
                ]"
                label-width="0px"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[row.$gjParentIndex].quantity"
                  :clearable="false"
                  @input="assemblyQuantityInput(row.$gjParentIndex, $event)"
                  placeholder="装配数量"
              ></gj-input>
            </el-form-item>
            <template v-else>
              {{form.items[row.$gjParentIndex].quantity}}
            </template>
          </template>
          <template v-slot:scale="{row}">
            <el-form-item
                v-if="addOpType || editOpType"
                :prop="`items.${row.$gjParentIndex}.childItems.${row.$gjChildIndex}.scale`"
                :rules="[
                  { required: true, message: '请输入数量', trigger: ['change'] },
                  $gjReRule(RE.pt, '请输入大于0的整数')
                ]"
                label-width="0px"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[row.$gjParentIndex].childItems[row.$gjChildIndex].scale"
                  :clearable="false"
                  @input="scaleInput(row.$gjParentIndex, row.$gjChildIndex, $event)"
                  placeholder="单位所需量"
              ></gj-input>
              <gj-button
                  v-if="form.items[row.$gjParentIndex].childItems.length > 1"
                  type="text"
                  style="margin-left: 8px;"
                  @click="deleteChildItem(row.$gjParentIndex, row.$gjChildIndex)">
                移除
              </gj-button>
            </el-form-item>
            <template v-else>
              {{form.items[row.$gjParentIndex].childItems[row.$gjChildIndex].scale}}
            </template>
          </template>
          <template v-slot:op="{row}">
            <div>
              <gj-button
                  type="text"
                  @click="deleteItem(row.$gjParentIndex)">
                删除
              </gj-button>
            </div>
            <gj-button
                type="text"
                @click="addChildProduct(row.$gjParentIndex)">
              添加子件
            </gj-button>
          </template>
        </gj-table>
      </el-form>
    </template>
    <template #footer>
      <gj-button
          @click="cancel"
      >取消</gj-button>
      <gj-button
          v-if="$permission('assemble:add') && !viewOpType"
          :loading="saveAsDraftLoading"
          @click="confirm(true)"
      >保存为草稿</gj-button>
      <gj-button
          v-if="$permission('assemble:add') && !viewOpType"
          type="primary"
          :loading="confirmLoading"
          @click="confirm(false)"
      >确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {formDeleteItemMixin, formRuleMixin, modalMixIn, opTypeMixin, responseMixin} from "@/minxins";
  import AppAddProductModal from "./add-product-modal";
  import AppAddChildProductModal from "./add-child-product-modal";
  import AppImportProductModal from "./import-product-modal";
  import {isMeaningful, isMeaningless} from "@/utils/common";
  import {addAssemblyOrder, getAssemblyOrderById, updateAssemblyOrder} from "@/api/warehouse";
  import {AssemblyOrderEnum} from "../../enum";

  export default {
    name: "app-op-assembly-order",
    mixins: [modalMixIn, opTypeMixin, formRuleMixin, formDeleteItemMixin, responseMixin],
    props: {
      assemblyOrder: {
        default: null
      },
      opType: {
        required: true
      }
    },
    data() {
      return {
        data: {},
        tableData: [],
        loading: false,
        contentLoading: false,
        columns: [],
        form: {
          warehouseId: null,
          memo: null,
          items: []
        },
        saveAsDraftLoading: false,
        labelWidth: '70px',
        label1Width: '70px',
        inputWidth: '100%',
        AssemblyOrderEnum: AssemblyOrderEnum
      }
    },
    created() {
      this.initColumns();
      if (this.viewOpType || this.editOpType) {
        this.contentLoading = true;
        this.inited = false;
        getAssemblyOrderById(this.assemblyOrder.id)
          .then(data => {
            this.data = data;
            this.form.warehouseId = data.warehouseId;
            this.form.memo = data.memo;
            this.form.items = data.items.map(item => this.mapToItem(item));
            this.$nextTick(() => this.inited = true);
          })
          .complete(() => this.contentLoading = false);
      }
    },
    watch: {
      'form.warehouseId': {
        handler: function () {
          // 重新选择仓库需清空产品
          // 未初始化数据，则回填初始数据
          if ((this.viewOpType || this.editOpType) && !this.inited) {
            return;
          }
          this.form.items = [];
        }
      }
    },
    methods: { // <div><gj-image :src="row.skuImageUrl"></gj-image></div>
      initColumns() {
        if (this.addOpType || this.editOpType) {
          this.columns = [
            {id: 'picture1', header: '组合产品图片', field: 'picture:skuImageUrl', width: '100px', align: 'center'},
            {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '200px'},
            {id: 'assemblyNum', header: '装配数量', field: 'slot:assemblyNum', required: true, width: '130px'},
            {id: 'picture', header: '图片', field: 'picture:childSkuImageUrl', width: '60px'},
            {id: 'childSku', header: '子件名称/SKU', field: 'slot:childSku', minWidth: '200px'},
            {id: 'availableQuantity', header: '库存可用量', field: 'availableQuantity', width: '90px', align: 'right'},
            {id: 'childQuantity', header: '所需量', field: 'childQuantity', width: '90px', align: 'right'},
            {id: 'scale', header: '单位所需量', field: 'slot:scale', required: true, width: '160px'},
            {id: 'op', header: '操作', field: 'slot:op', width: '80px'}
          ];
        }
        if (this.viewOpType) {
          this.columns = [
            {id: 'picture1', header: '组合产品图片', field: 'picture:skuImageUrl', width: '100px', align: 'center'},
            {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '200px'},
            {id: 'assemblyNum', header: '装配数量', field: 'slot:assemblyNum', width: '100px', align: 'right'},
            {id: 'picture', header: '图片', field: 'picture:childSkuImageUrl', width: '60px'},
            {id: 'childSku', header: '子件名称/SKU', field: 'slot:childSku', minWidth: '200px'},
            {id: 'childQuantity', header: '所需量', field: 'childQuantity', width: '100px', align: 'right'},
            {id: 'scale', header: '单位所需量', field: 'slot:scale', width: '100px', align: 'right'},
          ];
        }
      },
      assemblyQuantityInput(index, quantity) {
        this.form.items[index].childItems.forEach(childItem => {
          if (isNaN(quantity) || isNaN(childItem.scale)) {
            childItem.childQuantity = '-';
          } else {
            childItem.childQuantity = Number(quantity) * Number(childItem.scale);
          }
        });
        this.form.items = [...this.form.items];
      },
      scaleInput(index, childIndex, scale) {
        const item = this.form.items[index];
        const childItem = this.form.items[index].childItems[childIndex];
        if (isNaN(item.quantity) || isNaN(scale)) {
          childItem.childQuantity = '-';
        } else {
          childItem.childQuantity = Number(item.quantity) * Number(scale);
        }
        this.form.items = [...this.form.items];
      },
      addChildProduct(index) {
        this.$gjCreate(AppAddChildProductModal, {
          mountTo: this.mountTo,
          props: {
            warehouseId: this.form.warehouseId,
            hideSkuList: this.form.items[index].childItems.map(item => item.childSku)
          },
          on: {
            select: (products) => {
              const a = products.map(childItem => ({
                childSkuImageUrl: childItem.skuImageUrl,
                childSku: childItem.sku,
                childProductName: childItem.productName,
                availableQuantity: childItem.availableQuantity || 0,
                scale: null,
                childQuantity: childItem.quantity || null
              }));
              this.form.items[index].childItems.push(...a);
              this.form.items = [...this.form.items];
            }
          }
        });
      },
      addProduct() {
        if (!this.canAddProduct()) {
          return;
        }
        this.$gjCreate(AppAddProductModal, {
          mountTo: this.mountTo,
          props: {
            warehouseId: this.form.warehouseId,
            hideSkuList: this.form.items.map(item => item.sku)
          },
          on: {
            select: (products) => {
              this.tableData = this.tableData.concat(products);
              this.form.items = this.form.items.concat(products.map(item => this.mapToItem(item)));
            }
          }
        });
      },
      importProduct() {
        if (!this.canAddProduct()) {
          return;
        }
        this.$gjCreate(AppImportProductModal, {
          mountTo: this.mountTo,
          props: {
            warehouseId: this.form.warehouseId,
          },
          on: {
            importSuccess: (data) => {
              this.updateItems(data);
            },
            importPartSuccess: (data) => {
              this.updateItems(data);
            }
          }
        })
      },
      updateItems(data) {
        if (isMeaningful(data)) {
          data.forEach(newItem => {
            const find = this.form.items.find(oldItem => newItem.sku === oldItem.sku);
            if (find) {
              Object.assign(find, this.mapToItem(newItem));
            } else {
              this.form.items.push(this.mapToItem(newItem));
            }
          });
          this.form.items = [...this.form.items];
        }
      },
      canAddProduct() {
        if (isMeaningless(this.form.warehouseId)) {
          this.$gjMessage.error('请选择仓库');
          return false;
        }
        return true;
      },
      mapToItem(item) {
        return {
          id: item.id,
          sku: item.sku,
          skuImageUrl: item.skuImageUrl,
          productName: item.productName,
          quantity: item.quantity || null,
          childItems: (item.childItems || []).map(childItem => ({
            childId: childItem.id,
            childSkuImageUrl: childItem.skuImageUrl,
            childSku: childItem.sku,
            childProductName: childItem.productName,
            availableQuantity: childItem.availableQuantity || 0,
            scale: childItem.scale,
            childQuantity: childItem.quantity || null,
          }))
        };
      },
      deleteChildItem(index, childIndex) {
        this.form.items[index].childItems.splice(childIndex, 1);
        this.form.items = [...this.form.items];
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.form.items = [...this.form.items];
      },
      confirm(saveDraft) {
        if (this.formValidate()) {
          if (saveDraft) {
            this.saveAsDraftLoading = true;
          } else {
            this.confirmLoading = true;
          }
          Promise.resolve({
            id: this.assemblyOrder ? this.assemblyOrder.id : null,
            warehouseId: this.form.warehouseId,
            memo: this.form.memo,
            items: this.form.items.map(item => ({
              id: item.id,
              sku: item.sku,
              quantity: item.quantity,
              childItems: item.childItems.map(childItem => ({
                id: childItem.childId,
                quantity: childItem.childQuantity,
                scale: childItem.scale,
                sku: childItem.childSku
              }))
            })),
            saveDraft,
          })
            .then(params => {
              if (this.addOpType) {
                return addAssemblyOrder(params);
              }
              if (this.editOpType) {
                return updateAssemblyOrder(params);
              }
            })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                if (this.addOpType) {
                  this.$gjMessage.success(`生成装配单：${res.data}`);
                  this.$emit('created');
                }
                if (this.editOpType) {
                  this.$gjMessage.success(res.data);
                  this.$emit('updated');
                }
                this.$gjDestroy();
              });
            })
            .complete(() => {
              if (saveDraft) {
                this.saveAsDraftLoading = false;
              } else {
                this.confirmLoading = false;
              }
            })
        }
      },
      formValidate() {
        if (this.form.items.length === 0) {
          this.$gjMessage.error('请添加产品');
          return false;
        }
        if (!this.$gjFormValidate()) {
          return false;
        }
        return true;
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .vxe-body--row > .vxe-body--column:first-child .vxe-cell{
    padding-left: 10px;
  }
  /deep/ .gj-table{
    flex: 1;
    overflow: auto;
  }
</style>
